import 'react';
import { jsxs } from 'react/jsx-runtime';
import { isUndefined, isString, isArray, isObject } from '../../../utils/is.js';

const formatValue = (value, maxLength) => {
  const str = value !== null && !isUndefined(value) && !isString(value) ? String(value) : value || '';
  if (maxLength) {
    return str.slice(0, maxLength);
  }
  return str;
};
const inputAddon = (className, node, style = {}, clearButton) => {
  return node || clearButton ? /*#__PURE__*/jsxs("div", {
    style: style,
    className: className,
    children: [node, clearButton]
  }) : null;
};
const keepFocus = e => {
  e.target.tagName !== 'INPUT' && e.preventDefault();
};
const formatTaggedValue = value => {
  if (!isArray(value) || !value.length) {
    return undefined;
  }
  return value.map(item => {
    return isObject(item) ? item.value : item;
  });
};
const getInputClasses = ({
  clsx,
  styles,
  size,
  variant,
  suffix,
  disabled,
  validationStatus,
  prefix,
  allowClear,
  value,
  focus,
  withPrefixes,
  hasClear,
  withLabel
}) => {
  const isComplexInput = withPrefixes || allowClear;
  const labelClassNames = clsx(styles.label, {
    [styles.label_active]: focus || value
  });
  const inputVariantClassName = clsx({
    [styles.default]: variant === 'default',
    [styles.filled]: variant === 'filled',
    [styles.underlined]: variant === 'underlined'
  });
  const inputSizeClassName = clsx({
    [styles.xs]: size === 'xs',
    [styles.sm]: size === 'sm',
    [styles.md]: size === 'md',
    [styles.lg]: size === 'lg'
  });
  const validationStatusClassName = clsx({
    [styles.success]: validationStatus === 'success',
    [styles.warning]: validationStatus === 'warning',
    [styles.error]: validationStatus === 'error'
  });
  const inputGroupClassNames = clsx(styles.with_addons, {
    [styles.disabled]: disabled
  });
  const additionalInputClassNames = !withPrefixes && clsx(inputVariantClassName, inputSizeClassName, validationStatusClassName, {
    [styles.disabled]: disabled,
    [styles.focus]: focus && !isComplexInput
  });
  const inputClassNames = clsx(styles.input, {
    [styles.has_label]: withLabel
  }, additionalInputClassNames);
  const innerClassNames = clsx(styles.inner, inputVariantClassName, inputSizeClassName, validationStatusClassName, {
    [styles.disabled]: disabled,
    [styles.focus]: focus,
    [styles.has_prefix]: prefix && !suffix,
    [styles.has_suffix]: !prefix && suffix,
    [styles.has_both]: prefix && suffix,
    [styles.has_clear]: hasClear
  });
  return {
    inputGroupClassNames,
    inputClassNames,
    labelClassNames,
    innerClassNames
  };
};

export { formatTaggedValue, formatValue, getInputClasses, inputAddon, keepFocus };
